export default __webpack_public_path__ + "src/assets/icn-bullet.7c523094a2bcfbf4a1ba2634e0d577af.svg";